/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type CreateInventoryTransferDto = {
    /**
     * Destination location ID
     */
    destinationLocationId: number;
    /**
     * Array of warehouse inventory product IDs to transfer
     */
    warehouseInventoryProductIds: Array<number>;
    /**
     * Transfer status
     */
    status: CreateInventoryTransferDto.status;
    /**
     * Reason for return (only for branch-to-warehouse transfers)
     */
    returnReason?: string;
    /**
     * Notes or observations for the transfer
     */
    notes?: string;
    /**
     * Require manual product counting before accepting transfer
     */
    requireCounting?: boolean;
};
export namespace CreateInventoryTransferDto {
    /**
     * Transfer status
     */
    export enum status {
        PENDING = 'PENDING',
        COMPLETED = 'COMPLETED',
        CANCELLED = 'CANCELLED',
    }
}

